
const state = {
  pending: false,
  goBackActionName: null
}

const mutations = {
  setLoading(state, payload) {
    state.pending = payload
  },

  setGoBackAction(state, payload) {
    state.goBackActionName = payload
  }
}

const actions = {
  goBack({ dispatch, state }) {
    return dispatch(state.goBackActionName, undefined, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
